var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"container",staticClass:"fill-height mt-n3 mx-n4"},[_c('v-tabs',{ref:"tabs",attrs:{"active-class":"white","background-color":"grey lighten-3","hide-slider":"","show-arrows":""}},[_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-part-numbers'),
                params: {
                    projectId: _vm.projectId,
                },
            }}},[_vm._v(" PART NUMBERS ")]),_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-work-orders'),
                params: {
                    projectId: _vm.projectId,
                    project: _vm.project,
                },
            }}},[_vm._v(" WO ")]),_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-wo-progress'),
                params: {
                    projectId: _vm.projectId,
                    project: _vm.project,
                },
            }}},[_vm._v(" WO PROGRESS ")]),_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-bill-of-materials'),
                params: {
                    projectId: _vm.projectId,
                },
            }}},[_vm._v(" BOM ")]),_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-packing-lists'),
                params: {
                    projectId: _vm.projectId,
                },
            }}},[_vm._v(" PACKING LISTS ")]),_c('v-tab',{attrs:{"to":{
                name: _vm.activeRoute('project-wo-balance'),
                params: {
                    projectId: _vm.projectId,
                },
            }}},[_vm._v(" WO BALANCE ")])],1),_c('v-card',[_c('v-card-text',{staticClass:"overflow-y-auto",style:({ height: `${_vm.height}px` })},[_c('router-view')],1)],1),_c('Errors')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }